import * as React from "react"

const AznSvg = (props) => (

    <svg xmlns="http://www.w3.org/2000/svg" height="512" viewBox="0 0 512 512" width="512"  {...props}>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <g id="Currency">
                    <g id="Base">
                        <path d="m256 512a256 256 0 0 1 -181-437 256 256 0 0 1 362 362 254.33 254.33 0 0 1 -181 75z"
                              fill="#c17d2b"/>
                        <circle cx="256" cy="256" fill="#ffc500" r="237.45"/>
                        <circle cx="256" cy="256" fill="#e5a100" r="189.67"/>
                        <circle cx="256" cy="256" fill="#ffcf00" r="170.89"/>
                    </g>
                    <path
                        d="m175.85 348.35v-63q0-25 10-43.95a71.45 71.45 0 0 1 28.15-29.35q18.15-10.41 42-10.42t42 10.42a71.51 71.51 0 0 1 28.14 29.34q10 18.93 10 43.95v63h-26.54v-63.9q0-17.15-6.67-30.1a48.33 48.33 0 0 0 -18.79-20.07q-12.14-7.1-28.14-7.1t-28.14 7.11a48.42 48.42 0 0 0 -18.8 20.07q-6.66 13-6.66 30.1v63.9zm92.22-184.7v184.7h-25.92v-184.7z"
                        fill="#c17d2b"/>
                </g>
            </g>
        </g>
    </svg>
)

export default AznSvg
